<template>
  <form @submit="submit" class="form-container-contact">
    <label for="password">Current Password</label>
    <input
      type="password"
      v-model="current_password"
      id="password"
      required
    />
    <label for="new_password">New Password</label>
    <input
      type="password"
      v-model="password"
      id="new_password"
      required
    />
    <label for="confirm_password">Confirm New Password</label>
    <input
      type="password"
      v-model="confirm_password"
      id="confirm_password"
      required
    />
    <button type="submit" class="btn mx-0">
      <span v-if="!isloading">Save Password</span>
      <span v-else>Loading...</span>
    </button>
    <p v-if="error != ''" class="text-danger">{{ error }}</p>
  </form>
</template>

<script>
export default {
  name: "password-form",
  data() {
    return {
      current_password: "",
      password: "",
      confirm_password: "",
      error: "",
      isloading: false,
    };
  },
  methods: {
    submit(e) {
      e.preventDefault();
      if (this.password != this.confirm_password) {
        this.error = "New password & confirm password is not match";
      } else {
        this.isloading = true;
        this.$http
          .put("/api/v1/user/accounts/password", {
            account: {
              current_password: this.current_password,
              password: this.password,
              confirm_password: this.confirm_password,
            },
          })
          .then((res) => {
            this.$toast.success("New password updated successful", {
              position: "top-right",
            });
            window.location.href = "/users/sign_in?change_password=yes";
            this.isloading = false;
          })
          .catch((e) => {
            this.isloading = false;
            this.error = "Current password is not correct"
          });
      }
    },
  },
};
</script>
